export function isGitSha(value) {
    return /^[0-9a-f]{7,40}$/i.test(String(value || '').trim());
}

export function pinnedGazetteer(run) {
    if (!run) {
        return '';
    }
    if (isGitSha(run.gazetteerRevision)) {
        return String(run.gazetteerRevision).trim();
    }
    const types = ['cargo', 'vessel'];
    for (let i = 0; i < types.length; i += 1) {
        const slot = run.runVer && run.runVer[types[i]];
        const revision = slot && slot.gazetteers && slot.gazetteers.revision;
        if (isGitSha(revision)) {
            return String(revision).trim();
        }
    }
    return '';
}

export function formatMetric(value) {
    if (value === undefined || value === null || value === '') {
        return '—';
    }
    if (typeof value === 'number') {
        return value.toLocaleString();
    }
    return String(value);
}

export function formatDelta(value) {
    if (value === undefined || value === null || Number.isNaN(value)) {
        return '—';
    }
    if (value > 0) {
        return `+${value.toLocaleString()}`;
    }
    return value.toLocaleString();
}

export function formatSuiteLabel(row) {
    const id = row.id || row._id;
    const when = row.createdAt ? new Date(row.createdAt).toLocaleString() : id;
    return `${when} · ${row.reason || id}`;
}

export function runSelectionTip(row) {
    if (!row) {
        return '';
    }
    const id = row.id || row._id;
    if (!id) {
        return '';
    }
    const name = row.reason || id;
    return row.createdAt ? `${name} (${row.createdAt})` : String(name);
}

export function percentChange(from, to) {
    if (typeof from !== 'number' || typeof to !== 'number') {
        return undefined;
    }
    if (from === 0) {
        if (to === 0) {
            return 0;
        }
        return to > 0 ? Infinity : -Infinity;
    }
    return ((to - from) / Math.abs(from)) * 100;
}

export function colorForPercent(pct, lowerIsBetter) {
    const scored = lowerIsBetter && typeof pct === 'number' ? -pct : pct;
    if (scored === undefined || Number.isNaN(scored)) {
        return undefined;
    }
    if (scored < -30) {
        return '#ff1744';
    }
    if (scored < -10) {
        return '#ff5252';
    }
    if (scored < -5) {
        return '#ff8a80';
    }
    if (scored <= 5) {
        return '#000000';
    }
    if (scored <= 10) {
        return '#69f0ae';
    }
    if (scored <= 30) {
        return '#00e676';
    }
    return '#00c853';
}

export function formatPercent(pct) {
    if (pct === undefined || pct === null || Number.isNaN(pct)) {
        return '—';
    }
    if (pct === Infinity) {
        return '+∞%';
    }
    if (pct === -Infinity) {
        return '-∞%';
    }
    const digits = Math.abs(pct) >= 10 ? 0 : 1;
    const text = pct.toLocaleString(undefined, {
        maximumFractionDigits: digits,
        minimumFractionDigits: 0,
    });
    return pct > 0 ? `+${text}%` : `${text}%`;
}

function withSign(text, value, signed) {
    if (!signed || value <= 0 || text.charAt(0) === '-') {
        return text;
    }
    return `+${text}`;
}

export function formatSeconds(ms, signed) {
    if (ms === undefined || ms === null || ms === '' || Number.isNaN(ms)) {
        return '—';
    }
    const seconds = ms / 1000;
    const abs = Math.abs(seconds);
    const digits = abs >= 10 ? 1 : 2;
    const text = `${seconds.toLocaleString(undefined, {
        maximumFractionDigits: digits,
        minimumFractionDigits: 0,
    })} s`;
    return withSign(text, seconds, signed);
}

export function formatBytes(bytes, signed) {
    if (bytes === undefined || bytes === null || bytes === '' || Number.isNaN(bytes)) {
        return '—';
    }
    const abs = Math.abs(bytes);
    const sign = signed && bytes > 0 ? '+' : bytes < 0 ? '-' : '';
    if (abs < 1024) {
        return `${sign}${abs.toLocaleString()} B`;
    }
    if (abs < 1024 * 1024) {
        return `${sign}${(abs / 1024).toLocaleString(undefined, { maximumFractionDigits: 1 })} KB`;
    }
    if (abs < 1024 * 1024 * 1024) {
        return `${sign}${(abs / (1024 * 1024)).toLocaleString(undefined, { maximumFractionDigits: 1 })} MB`;
    }
    return `${sign}${(abs / (1024 * 1024 * 1024)).toLocaleString(undefined, { maximumFractionDigits: 2 })} GB`;
}

export function formatCompare(fromText, toText) {
    if (fromText === toText) {
        return fromText;
    }
    return `${fromText} → ${toText}`;
}

export function formatByKind(value, kind, signed) {
    if (kind === 'time') {
        return formatSeconds(value, signed);
    }
    if (kind === 'bytes') {
        return formatBytes(value, signed);
    }
    if (signed) {
        return formatDelta(value);
    }
    return formatMetric(value);
}



// WEBPACK FOOTER //
// ./app/components/TestRuns/metrics.js